import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RelatorioCobrancaComponent } from './relatorio-cobranca.component';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../shared/shared.module';
import { NgxLoadingModule } from 'ngx-loading';
import { DateAdapter, MatButtonModule, MatCardModule, MatCheckboxModule, MatDatepickerModule, MatDialogModule, MatFormFieldModule, MatIconModule, MatInputModule, MatNativeDateModule, MatPaginatorModule, MatSelectModule, MatSort, MatSortModule, MatTableModule, MatTooltipModule, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material';
import { Ng4LoadingSpinnerModule } from 'ng4-loading-spinner';
import { FuseSharedModule } from '@fuse/shared.module';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { NgxMaskModule } from 'ngx-mask';

const routes = [
    {
        path: 'relatorioCobranca',
        component: RelatorioCobrancaComponent
    }
];
@NgModule({
    declarations: [RelatorioCobrancaComponent],
    imports: [
        CommonModule,
        RouterModule.forChild(routes),
        SharedModule,
        NgxLoadingModule.forRoot({ fullScreenBackdrop: true }),
        Ng4LoadingSpinnerModule,
        MatButtonModule,
        FuseSharedModule,
        MatDatepickerModule,
        MatFormFieldModule,
        MatInputModule,
        MatIconModule,
        MatSelectModule,
        MatCheckboxModule,
        MatTableModule,
        MatPaginatorModule,
        MatNativeDateModule,
        MatDialogModule,
        MatCardModule,
        MatSortModule,
        MatTooltipModule,
        NgxMaskModule.forRoot()
    ],
    exports: [RelatorioCobrancaComponent],
    providers: [
      // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
      // application's root module. We provide it at the component level here, due to limitations of
      // our example generation script.
      //{provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]},
  
    ],
   
})
export class RelatorioCobrancaModule { }
